import React from 'react'

const Header = () => {
    return (
        <div>
            <div className='grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 '>
                <div className='py-3 px-4 light-shadow flex flex-col rounded-md items-center text-dark'>
                    <p className='text-lg font-bold text-primary'>44B</p>
                    <p>Impressions/mo</p>
                </div>
                <div className='py-3 px-4 light-shadow flex flex-col rounded-md items-center text-dark'>
                    <p className='text-lg font-bold text-primary'>$11.00</p>
                    <p>eCPM Average</p>
                </div>
                <div className='py-3 px-4 light-shadow flex flex-col rounded-md items-center text-dark'>
                    <p className='text-lg font-bold text-primary'>686.2k</p>
                    <p>Targetable Screens</p>
                </div>
                <div className='py-3 px-4 light-shadow flex flex-col rounded-md items-center text-dark'>
                    <p className='text-lg font-bold text-primary'>37</p>
                    <p>Venue Types</p>
                </div>
                <div className='py-3 px-4 light-shadow flex flex-col rounded-md items-center text-dark'>
                    <p className='text-lg font-bold text-primary'>$280</p>
                    <p>Total Payments</p>
                </div>
            </div>
        </div>
    )
}

export default Header